var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(58165),
		__webpack_require__.e(13325)
	]).then(next);
};